import { Component, Vue } from 'vue-property-decorator'

@Component
export default class couponCenter extends Vue{
    couponTotal = 0//券总数
    couType = ['店铺券','商品券','运费券','充值券','通用券','品类券','特殊标签限制券','特殊标签限制券','品牌券']//现在只有2商品券和6品类券
    getCoupon = false
    couponList = []
    currentPage = 1
    errorMsg:any = {
        '2012':'优惠券领取活动已结束',
        '2013':'优惠券已被领完',
        '2014':'您的领取数量已达上限',
    }
    dialogSuccVisible = false
    dialogFailVisible = false
    clickCouponId = ''
    clickType:any = ''
    Sencond = 5
    interval:any = ''
    failText = ''
    created() {
        this.getcouponList()
    }
    getcouponList(){
        // 接口wiki http://wiki.uletm.com/pages/viewpage.action?pageId=50122428
        let message:any = {
            businessType:'2',//1-零售 2-批销 3-线下进销存
            pageSize:12,
            showChannelCode:'general',//	展示渠道码明细 渠道编码区分大小写！ 后面为非必填参数
            userOnlyid:'',
            categoryId:'',
            couponType:'',
            batchId:'',
            provinceTubeId:'',
            sort:'',
        }
        message.pageIndex = this.currentPage,
        message.callbackQuery = 'jsoncallback'
        this.$jsonp(`//wallet${window.domain}/wallet-pn-web/couponWallCipherControllerV1/searchCouponWall`,message).then((data:any) => {
            let obj = data.returnMsg.couponList
            obj.map((item:any) => {
                item.lqFlag = false
                if(item.stock == 0){
                    item.text = '已领完'
                } else {
                    item.text = '立即领取'
                }
                if(item.couponType == 2){//商品券
                    item.title = item.listingName
                    item.showUrl = item.listingImgurl.split(',')
                } else if(item.couponType == 6){//品类券
                    let categoryLen = item.categoryName.split(',')
                    item.showUrl = item.categoryImgurl.split(',')[0]
                    if(categoryLen > 1){//多品类单品类判断
                        item.title = '仅限购买指定品类商品使用'
                    } else {
                        item.title = '仅限购买' + item.categoryName + '商品使用'
                    }
                    
                }
            })
            this.couponTotal = data.returnMsg.couponTotal
            this.couponList = data.returnMsg.couponList
        },((err:any) => {
        }))
    }
    handlegetCoupon(item:any){
        if(item.couponWallFlag == 2){
            return false
        }
        let params:any = {
            batchIdCipher:item.batchIdCipher
        }
        params.callbackQuery = 'jsoncallback'
        this.$jsonp(`//wholesale${window.domain}/fxYzgApi/coupon/receiveCoupon.do`,params).then((data:any) => {
            if(data.data.code == '0000'){
                console.log(item)
                this.dialogSuccVisible = true
                item.lqFlag = true
                this.clickCouponId = item.batchId
                this.clickType = item.couponType
                this.getCoupon = true
                this.getSencond()
            } else {
                if(data.data.code == '2014'){
                    item.lqFlag = true
                    this.clickCouponId = item.batchId
                    this.clickType = item.couponType
                    this.getCoupon = true
                }
                this.failText = this.errorMsg[data.data.code] || '领取失败，此优惠券十分抢手可能存在领不到的情况',
                this.dialogFailVisible = true
                this.getSencond()
            }
            
        }).catch((err:any) => {
            
        })
    }
    next(){
        this.currentPage++
        this.getcouponList()
    }
    prev(){
        this.currentPage--
        this.getcouponList()
    }
    handleCurrentChange(cup:number){
        this.currentPage = cup
        this.getcouponList()
    }
    getSencond () {
        // const that = this
        this.interval = setInterval(()=> {
            this.Sencond--
          if (this.Sencond === 0) {
            this.dialogSuccVisible = false
            this.dialogFailVisible = false
            window.clearInterval(this.interval)
            this.sendMsg()//倒计时结束时运行的业务逻辑，这里的是关闭当前页面
          }
        }, 1000)
      }
      sendMsg(){
        this.Sencond = 5
        // window.close()
      }
      use(item:any){
        if(item.batchId){
            if(item.couponType == 2){
                window.location.href = '//wholesale'+ window.domain +'/fxZone/coupon/couponPolymerizeList.do?batchId='+ item.batchId +'&currentPage=1'
            } else {
                window.location.href = '//wholesale'+ window.domain +'/fxZone/list.do'
            }
        } else {
            if(this.clickType == 2){
                window.location.href = '//wholesale'+ window.domain +'/fxZone/coupon/couponPolymerizeList.do?batchId='+ this.clickCouponId +'&currentPage=1'
            } else {
                window.location.href = '//wholesale'+ window.domain +'/fxZone/list.do'
            }
        }
      }
      myCoupon(){
        window.location.href = '//my'+ window.domain +'/mywallet/coupon/queryCouponDetail.do'
      }
      gb(){
        this.sendMsg()
        window.clearInterval(this.interval)
      }
}